import {Navigate} from "react-router-dom-v5-compat";

import {preserveMarketingParams} from "@khan/urls";

import MaybeAutomaticallyLoginToSubdomain from "./maybe-automatically-login-to-subdomain.tsx";

// WARNING: This function should only be called if we know the user is logged in.
export function loggedInRedirect(continueUrl: string) {
    const decodedContinueUrl = decodeURIComponent(continueUrl);
    if (decodedContinueUrl.startsWith("https://")) {
        const parsedContinueUrl = new URL(decodedContinueUrl);
        return (
            <MaybeAutomaticallyLoginToSubdomain
                continueURL={parsedContinueUrl}
            />
        );
    }

    return (
        <Navigate
            to={preserveMarketingParams(
                continueUrl,
                new URLSearchParams(location.search),
            )}
        />
    );
}
